export class OperacionParametrica {
    IdTabla: number;
    Operacion: string;
    Columnas: string;
    Valores: string;
    ColumnaPK: string;
    ValorPK: string;
}